export const CONTENT_PROVIDER_TYPES = [
  { id: 'ORGANIZATION', name: 'Байгууллага' },
  { id: 'PERSON', name: 'Хувь хүн' },
];
